import { Injectable, Signal, computed, effect, signal } from '@angular/core';
import { Borrower } from '../../models/borrower';
import {
  Application,
  OtpMethod,
} from '../../models/application';

/**
 * Application state for the standalone application flow
 */
export interface State {
  borrower: Borrower | null;
  application: Application | null;
  dealerId: string | null; // Dealer id from URL query param ?dealerId=... (persisted when present on any route)
  otpMethod: OtpMethod | null;
}

@Injectable({ providedIn: 'root' })
export class StoreService {
  private stateSig = signal<State>({
    borrower: null,
    application: null,
    dealerId: null,
    otpMethod: null,
  });

  readonly borrower: Signal<Borrower | null> = computed(() => this.stateSig().borrower);
  readonly application: Signal<Application | null> = computed(() => this.stateSig().application);
  readonly dealerId: Signal<string | null> = computed(() => this.stateSig().dealerId);
  readonly otpMethod: Signal<OtpMethod | null> = computed(
    () => this.stateSig().otpMethod,
  );

  constructor() {
    effect(() => {
      this.stateSig();
    });
  }

  get snapshot(): State {
    return this.stateSig();
  }

  setBorrower(borrower: Borrower | null): void {
    this.stateSig.update((s) => ({ ...s, borrower }));
  }

  setApplication(application: Application | null): void {
    this.stateSig.update((s) => ({ ...s, application }));
  }

  setDealerId(dealerId: string | null): void {
    this.stateSig.update((s) => ({ ...s, dealerId }));
  }

  setOtpMethod(method: OtpMethod): void {
    this.stateSig.update((s) => ({ ...s, otpMethod: method }));
  }
}
